/* eslint-disable no-magic-numbers */
export default {
  label: {
    base: {
      cursor: 'pointer',
      fontFamily: 'base',
      display: 'flex',
      alignItems: 'center',
      backgroundColor: 'grey-05',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'transparent',
      padding: 'sm',
      maxWidth: ['100%', 356, 608],
      width: '100%',
      variant: 'spark.base.wrapper',
      hover: {
        backgroundColor: 'grey-10'
      },
      focus: {
        backgroundColor: 'grey-0',
        boxShadow: 'radioFocus'
      }
    },
    variants: {
      checked: {
        backgroundColor: 'cyan-10'
      },
      disabled: {
        variant: 'spark.element.booleanInput.label.base',
        cursor: 'initial',
        opacity: 0.5,
        backgroundColor: 'grey-0'
      }
    }
  }
};